<template>
  <content-scroll-container
    class="flex-1 h-full"
    :scroll="false"
    :overflow-visible="true"
  >
    <content-scroll-inner class="h-full flex flex-col justify-start">
      <top-sub-a justify="justify-end">
        <div class="flex justify-center content-end h-full">
          <div
            class="flex items-end border-b-2 lg:border-b-2px border-interaction-light text-interaction-light h-full"
          >
            <div
              class="h-full flex flex-col justify-end cursor-pointer pr-5"
              @click="clearSearch"
            >
              <button
                class="flex-shrink-0 border-transparent hover:text-gray-600 -mb-1"
                type="button"
                v-show="search !== ''"
              >
                x
              </button>
            </div>
            <div
              class="h-full flex flex-col justify-end cursor-pointer"
              @click="showSearch"
            >
              <span
                class="pr-2 h-6 w-64 text-center italic text-chplus-s text-white -mb-1 truncate"
                >{{ search }}</span
              >
            </div>
          </div>
          <div
            class="h-full flex flex-col justify-end cursor-pointer"
            @click="showSearch"
          >
            <button
              class="border-transparent hover:text-gray-600 -mb-1"
              type="button"
            >
              <icon-search />
            </button>
          </div>
        </div>
      </top-sub-a>
      <div class="text-chplus-s text-white whitespace-no-wrap mt-1 mb-8">
        <p
          v-html="
            $t('components.nav.title_box.council_candidates', {
              council: activeElection.label,
              candidates: candidates.length
            })
          "
        ></p>
      </div>
      <div class="relative bg-white rounded-xxl pt-10 pb-2 h-full">
        <candidate-slot-grid
          ref="scrollarea"
          style="height: 100%;"
          class="overflow-y-scroll overflow-x-hidden mb-2"
          v-if="candidates.length > 0"
          :candidate-ids="candidates"
          @scroll="onScroll"
          @mountedCandidateSlotGrid="onSlotGridMounted"
        ></candidate-slot-grid>
        <div
          v-if="!loaded"
          class="absolute rounded-xxl top-0 left-0 w-full h-full"
          style="background-color:rgba(255,255,255,0.8)"
        ></div>
      </div>
    </content-scroll-inner>
  </content-scroll-container>
</template>

<script>
import Vue from "vue";
import TopSubA from "@/components/layouts/TopSubA";
import CandidateSlotGrid from "@/components/people/CandidateSlotGrid";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import IconSearch from "@/components/icons/IconSearch";
import { mapGetters } from "vuex";

export default {
  name: "AllCandidates",
  components: {
    TopSubA,
    CandidateSlotGrid,
    ContentScrollContainer,
    ContentScrollInner,
    IconSearch
  },
  props: {
    candidates: {
      type: Array,
      required: true
    },
    /**
     * @description Used for communication with the SortingButtons component.
     */
    sortingBus: {
      type: Vue,
      required: true
    },
    initialState: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      search: "",
      scroll: 0,
      lastScroll: 0,
      scrollTimeout: 0,
      loaded: false
    };
  },
  computed: {
    ...mapGetters("election", ["activeElection"])
  },
  beforeDestroy() {
    this.clearSearch();
  },
  mounted() {
    this.sortingBus.$on("search", this.onSearch);

    if (this.initialState) {
      if (this.initialState.filter && this.initialState.filter.search) {
        this.search = this.initialState.filter.search;
      }
      this.lastScroll = this.scroll;
    }

    this.runScrollEmitter();
  },
  methods: {
    showSearch() {
      this.sortingBus.$emit("showSearch", this.search);
    },
    clearSearch() {
      this.search = "";
      this.sortingBus.$emit("search", this.search);
    },
    onSlotGridMounted() {
      const initialScroll = this.initialState.allCandidatesScroll;
      this.scroll = initialScroll;
      this.$refs.scrollarea.$el.scrollTop = initialScroll;
      this.loaded = true;
    },
    onSearch(search) {
      this.search = search;
    },
    onScroll(event) {
      this.scroll = event.target.scrollTop;
      this.scrollTimeout = 400;
    },
    runScrollEmitter() {
      if (this.lastScroll !== this.scroll && this.scrollTimeout <= 0) {
        this.$emit("scroll", this.scroll);
        this.lastScroll = this.scroll;
      } else if (this.scrollTimeout > 0) {
        this.scrollTimeout -= 200;
      }
      setTimeout(() => this.runScrollEmitter(), 200);
    }
  }
};
</script>
